import { render, staticRenderFns } from "./NewResellerAgentDialog.vue?vue&type=template&id=9e4724bc&"
import script from "./NewResellerAgentDialog.vue?vue&type=script&lang=js&"
export * from "./NewResellerAgentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewResellerAgentDialog.vue"
export default component.exports